/**
 * quick-add-mab.js
 * Injects distiller name (above) and region (below) the product title,
 * and short description above the content grid, in the quick-add modal.
 *
 * Heritage uses two different title structures:
 *   Desktop: .view-product-title > a  (inside .product-details)
 *   Mobile:  .product-header > a      (direct child, no .view-product-title wrapper)
 */
(function () {
  let pendingMeta = null;

  // Capture phase: store product context when "Choose" is clicked
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.quick-add__button--choose');
      if (!btn) return;
      const container = btn.closest('[data-mab-distiller], [data-mab-region], [data-mab-short-desc]');
      if (!container) return;
      pendingMeta = {
        distiller: container.dataset.mabDistiller || '',
        region:    container.dataset.mabRegion    || '',
        shortDesc: container.dataset.mabShortDesc || '',
      };
    },
    true
  );

  // Observer: inject when dialog opens (content is loaded before showModal())
  const dialog = document.querySelector('#quick-add-dialog dialog');
  if (!dialog) return;

  new MutationObserver(() => {
    if (!dialog.hasAttribute('open') || !pendingMeta) return;

    const { distiller, region, shortDesc } = pendingMeta;
    pendingMeta = null;

    if (!distiller && !region && !shortDesc) return;

    // Remove any previously injected elements
    dialog.querySelectorAll('.mab-modal-distiller, .mab-modal-region, .mab-modal-desc').forEach(el => el.remove());

    // Find title element — desktop: .view-product-title wrapper; mobile: .product-header > a
    const titleWrapper = dialog.querySelector('.view-product-title');
    const titleEl = titleWrapper || dialog.querySelector('.product-header > a');

    if (titleEl && (distiller || region)) {
      if (distiller) {
        const el = document.createElement('div');
        el.className = 'mab-modal-distiller mab-card-distiller mab-preheader';
        el.textContent = distiller;
        titleEl.parentElement.insertBefore(el, titleEl);
      }
      if (region) {
        const el = document.createElement('div');
        el.className = 'mab-modal-region mab-card-region';
        el.textContent = region;
        titleEl.insertAdjacentElement('afterend', el);
      }
    }

    // Short description above the content grid (outside the image/details grid)
    if (shortDesc) {
      const el = document.createElement('p');
      el.className = 'mab-modal-desc';
      el.textContent = shortDesc;
      const content = dialog.querySelector('#quick-add-modal-content');
      if (content) dialog.insertBefore(el, content);
    }
  }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
})();
